import React, { useState, useEffect, useRef } from "react";
import { ImagesContext } from "./app_context/app_context";
import "./assets/styles/banner_image.scss";

const BannerImage = () => {
  const imagesData = React.useContext(ImagesContext);
  const { images }: any = imagesData;
  const imageList = [images.pnp_making, images.pnp_machine, images.pnp_rolls];

  // State to track current image index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Effect to automatically change slides every 15 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % imageList.length);
    }, 15000);

    return () => clearInterval(interval);
  }, [imageList.length]);

  // Function to manually change slides
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <>
      <div className="carousel">
        {imageList.map((image, index) => (
          <div
            key={index}
            className={`carousel__slide ${
              index === currentIndex ? "carousel__slide--active" : ""
            }`}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}

        {/* Carousel indicators */}
        <div className="carousel__indicators">
          {imageList.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`carousel__indicator ${
                index === currentIndex ? "carousel__indicator--active" : ""
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default BannerImage;
